// THIS VALUES ARE USED DURING CLIENT APP COMPILATION, PLEASE DO NOT MOVE
const initialAppId = 'app_nojRgWq2oKAG3rQirSPEQu'
const initialProjectId = 'proj_wg3CwnneZQjAWr9LspSsLt'
// eslint-disable-next-line import/newline-after-import, @typescript-eslint/no-var-requires
const initialBuildOrdersOnApp = require('./buildOrders.loaded.json')
const initialRunningMode = 'premium'
const initialCustomFontName = undefined
// #################

export const initialAppState = {
    appId: initialAppId,
    projectId: initialProjectId,
    buildOrders: initialBuildOrdersOnApp,
    runningMode: initialRunningMode,
    customFontName: initialCustomFontName,
} as const
